import useMutate from '@hooks/mutations/useMutate';
import useTapCoin from '@hooks/mutations/useTapCoin';
import { useIsDevNet } from '@hooks/other/useIsDevnet';
import { useIsSmall } from '@hooks/other/useIsSmall';
import useCoins from '@hooks/queries/cn/useCoin';
import React from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { Tooltip, Typography } from '@mui/material';
import { fmt } from '../../utils/common';
import { ERR_TAP_COIN, SUC_TAP_COIN } from '../../utils/strings';

export const CantonBalance: React.FC = () => {
  const isDevNet = useIsDevNet();
  const { showBoundary } = useErrorBoundary<Error>();
  const mutate = useMutate();

  const coin = useCoins();
  const tapCoin = useTapCoin();
  const isSmall = useIsSmall();
  const decimalPlaces = isSmall ? 2 : 8;
  const tap = React.useCallback(() => {
    mutate(tapCoin, { amount: '1000000.0' }, SUC_TAP_COIN, ERR_TAP_COIN).catch((error: Error) =>
      showBoundary(error),
    );
  }, [tapCoin, mutate, showBoundary]);

  const balance = coin.data
    ? coin.data.reduce((acc, c) => acc + parseFloat(c.payload.amount.initialAmount), 0)
    : 0;

  return (
    <Tooltip arrow title={isDevNet ? 'Add more CC' : undefined}>
      <Typography
        onClick={isDevNet ? tap : undefined}
        sx={{ cursor: 'pointer', mr: 1 }}
        variant="body2"
      >
        {fmt(balance, decimalPlaces)} CC
      </Typography>
    </Tooltip>
  );
};
